// extracted by mini-css-extract-plugin
export default {"select_wrapper":"TestFrequencyInputs_select_wrapper__3cIDp","select_root":"TestFrequencyInputs_select_root__VVgM2"};